import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class OneDriveFspConfig<T extends EMode = EMode.entity> {
  /** Alias: siteId */
  siteId?: string;
  /** Alias: driveId */
  driveId?: string;
  /** Alias: clientId */
  clientId?: string;
  /** Alias: tenantId */
  tenantId?: string;
  /** Alias: clientSecret */
  clientSecret?: string;

  __typename?: string;
}

const fields: FieldDefinitions<OneDriveFspConfig> = {
  siteId: {
    alias: 'siteId',
  },
  driveId: {
    alias: 'driveId',
  },
  clientId: {
    alias: 'clientId',
  },
  tenantId: {
    alias: 'tenantId',
  },
  clientSecret: {
    alias: 'clientSecret',
  },
  __typename: {
    alias: '__typename',
  },
};

export const oneDriveFspConfigEntityDefinition: EntitiyDefinition<OneDriveFspConfig> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'OneDriveFspConfig',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
